import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, InputWithIcon } from '@livable/saas-react-components';
import { Container, TextField, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TenanciesBatchActions } from 'src/components/property/TenanciesBatchActions';
import { ResidenciesDataGrid } from 'src/components/property/ResidenciesDataGrid';
import ResidentModal from 'src/components/resident/ResidentModal';
import { FormerResidentsTable } from 'src/pages/ResidentsPage/FormerResidentsTable';
import { RESIDENCY_STATUS_KEY_VALUES } from 'src/constants/residency';
import { useStore } from 'src/stores';
import useStyles from './styles';
export const ResidenciesTab = observer(_ref => {
  let activeResidency = _ref.activeResidency,
    buildingId = _ref.buildingId,
    propertyId = _ref.propertyId;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const selectedUnit = store.fse.FSEBillModalData;
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedRows = _useState2[0],
    setSelectedRows = _useState2[1];
  const _useState3 = useState('overview'),
    _useState4 = _slicedToArray(_useState3, 2),
    activeTab = _useState4[0],
    setActiveTab = _useState4[1];
  const _useState5 = useState('livable-solution'),
    _useState6 = _slicedToArray(_useState5, 2),
    livableTab = _useState6[0],
    setLivableTab = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    residentModalIsOpen = _useState8[0],
    setResidentModalIsOpen = _useState8[1];
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    searchKey = _useState0[0],
    setSearchKey = _useState0[1];
  const _useState1 = useState(RESIDENCY_STATUS_KEY_VALUES.Current),
    _useState10 = _slicedToArray(_useState1, 2),
    residentTab = _useState10[0],
    setResidentTab = _useState10[1];
  const isFormerResidents = [RESIDENCY_STATUS_KEY_VALUES.FormerActive, RESIDENCY_STATUS_KEY_VALUES.FormerClosed, RESIDENCY_STATUS_KEY_VALUES.FormerActive + '_' + RESIDENCY_STATUS_KEY_VALUES.FormerClosed].includes(residentTab);
  const handleResidentsTabChange = (e, value) => {
    if (value !== undefined && value !== null) setResidentTab(value);
    setSelectedRows([]);
  };
  const closeResidentModal = () => setResidentModalIsOpen(false);
  const openResidentModal = tab => {
    if (['billing-settings', 'livable-solution', 'occupancy'].includes(tab)) {
      setActiveTab('livable-solution');
      setLivableTab(tab);
    } else {
      setActiveTab(tab);
    }
    setResidentModalIsOpen(true);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "".concat(classes.containerDefault, " ").concat(selectedRows.length > 0 ? classes.containerSmall : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchBar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "tenancies-search",
    label: t('residencies_page.search_in_the_list'),
    variant: "outlined",
    value: searchKey,
    onChange: e => {
      var _e$target;
      return setSearchKey(e === null || e === void 0 || (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
    },
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    onChange: handleResidentsTabChange,
    value: residentTab,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: RESIDENCY_STATUS_KEY_VALUES.FormerActive + '_' + RESIDENCY_STATUS_KEY_VALUES.FormerClosed
  }, t('residencies_page.former_residents')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: RESIDENCY_STATUS_KEY_VALUES.Current
  }, t('residencies_page.active_residents')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: RESIDENCY_STATUS_KEY_VALUES.Future
  }, t('residencies_page.future_residents')))), (residentTab === RESIDENCY_STATUS_KEY_VALUES.Current || residentTab === RESIDENCY_STATUS_KEY_VALUES.Future) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ResidenciesDataGrid, {
    updateRowsCount: setSelectedRows,
    selectedRows: selectedRows,
    setSelectedRows: setSelectedRows,
    buildingId: buildingId,
    propertyId: propertyId,
    activeResidency: activeResidency,
    residenciesFilterStatus: residentTab,
    searchKey: searchKey
  })), isFormerResidents && /*#__PURE__*/React.createElement(FormerResidentsTable, {
    buildingId: buildingId,
    openResidentModal: openResidentModal,
    propertyId: propertyId,
    recidenciesFilterStatus: residentTab,
    searchKey: searchKey
  }), /*#__PURE__*/React.createElement(ResidentModal, {
    accountId: selectedUnit.accountId,
    activeResidency: activeResidency,
    activeTab: activeTab,
    isOpen: residentModalIsOpen,
    handleClose: closeResidentModal,
    handleOpen: openResidentModal,
    livableTab: livableTab,
    propertyId: propertyId,
    residencyId: selectedUnit.residencyId,
    setActiveTab: setActiveTab,
    unitName: selectedUnit.unitName
    // handleNavigation={handleNavigation}
    // dataNavigation={dataNavigation}
  })), store.residenciesMultiActionStore.selectedDetails.length > 0 && /*#__PURE__*/React.createElement(TenanciesBatchActions, null));
});